import React, { FC } from 'react';
import MuiStepButton, { StepButtonProps as MuiStepButtonProps } from '@mui/material/StepButton';
import { BpDesignSystem } from '../../types';
import { Typography } from '../Typography';
import { mergeClassNames } from '../../utils';

export type StepButtonProps = BpDesignSystem.PropsWithChildren<
  MuiStepButtonProps & {
    error?: boolean;
  }
>;

export const StepButton: FC<StepButtonProps> = ({ dataTest, className, error, ...rest }) => (
  <MuiStepButton
    data-test={dataTest}
    className={mergeClassNames(className, {
      'MuiStep-error': error
    })}
    {...rest}
  />
);

export const StepButtonVertical: FC<StepButtonProps & { subtitle?: React.ReactNode }> = ({
  dataTest,
  subtitle,
  children,
  error,
  className,
  ...rest
}) => (
  <MuiStepButton
    data-test={dataTest}
    className={mergeClassNames(className, {
      'MuiStep-error': error
    })}
    {...rest}
  >
    {!!subtitle && <Typography.Body color="colorOnSurfaceVariant">{subtitle}</Typography.Body>}
    <Typography.Title>{children}</Typography.Title>
  </MuiStepButton>
);
